export function sendHomeRedirectLinkEvent() {
  window.dataLayer.push({
    "event": "cms_object",
    "event_type": "ux_interaction",
    "object_category": "home_logo_link",
    "object_name": "client_panel",
    "gtm.uniqueEventId": 145
  })
}

